// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__3GiYq","message":"CookieConsent_message__2ULKf","cookieLink":"CookieConsent_cookieLink__25Q3F","continueBtn":"CookieConsent_continueBtn__3-ep4"};